export default __webpack_public_path__ + "static/media/register_m-ic.07496d02.svg";